import React from 'react';

type PickInsightsComponentProps = {
  children: JSX.Element;
};

function PickInsights({ children }: PickInsightsComponentProps) {
  return <div className="pickInsights__route">{children}</div>;
}

export default PickInsights;
